import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {KeycloakService} from './../authentication/keycloak.service';
import {AuthenticationService} from '../authentication/authentication.service';
import * as _ from 'lodash';
import {from, Observable} from 'rxjs';

/**
 * Allows or denies access to paths requiring specific roles defined in app's router.
 */
@Injectable()
export class O7AuthGuard implements CanActivate, CanActivateChild {

  constructor(
    protected router: Router,
    protected keycloakService: KeycloakService,
    private authenticationService: AuthenticationService
  ) {}

  private async isAccessAllowed(route: ActivatedRouteSnapshot): Promise<boolean> {
    const isAuthenticated: boolean = await this.keycloakService.isAuthenticated();

    if (!isAuthenticated) {
      await this.keycloakService.setupAuthentication(); // Redirect to login
      return false;
    }

    const requiredRoles: string[] = _.defaultTo(_.get(route, 'data.allowedRoles'), []);
    if (requiredRoles.length == 0 || this.authenticationService.hasAnyRole(requiredRoles)) {
      return true;
    } else {
      const dashboardName: string = _.get(route, 'data.dashboard.title', '');
      this.router.navigate(['unauthorized', dashboardName]);
      return false;
    }
  }

  canActivate(
    activatedRouteSnapshot: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return from(this.isAccessAllowed(activatedRouteSnapshot));
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return from(this.isAccessAllowed(childRoute));
  }
}
